import { Injectable } from '@angular/core';
import {CanActivate, Router} from "@angular/router";
import {LoginService} from "@app/login/login.service";

@Injectable({
  providedIn: "root"
})
export class RouteGuardService implements CanActivate{

  constructor(private router: Router, private loginService: LoginService) {
  }

  canActivate(): Promise<boolean> {
    return this.loginService.isLoggedIn.then(loggedIn => {
      if (loggedIn && sessionStorage.getItem('activeUser')) {
        return true;
      } else {
        this.notPermitted();
        return false;
      }
    });
  }
  notPermitted() {
    this.router.navigate(['/signin'])
  }
}
